var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "calendar-view-selector", class: _vm.isMobile && "row" },
    _vm._l(_vm.viewModes, function(item, index) {
      return _c(
        "div",
        {
          key: "calendarViewSelector" + index,
          staticClass: "col-3",
          class: [{ active: item.id == _vm.value, "mx-0": _vm.isMobile }],
          on: {
            click: function($event) {
              return _vm.Value(item)
            }
          }
        },
        [_c("span", [_vm._v(_vm._s(item.name))])]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }